import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";

// constants
import LanguageSetting from "LanguageSetting";

// actions
import { updateUnsavedChanges } from "DashboardMenuAction";
import { fetchEventDetails } from "DashboardUserAction";
import { fetchTemplate, fetchEmailLog } from "SettingActions";
import { fetchEvent } from "ActionsMessage";
import { fetchSettings } from "TicketAction";

// components
import SettingMenu from "./components/common/setting-menu";
import PasswordSetting from "PasswordSetting";
import EventSetting from "EventSetting";
import EmailTemplate from "EmailTemplate";
import EmailLog from "EmailLog";
import APIS from "APIS";
import BillingDetails from "BILLINGDETAILS";

class Settings extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchTemplate(this.props.session);

    this.props.fetchEvent(this.props.session);
    this.props.fetchEventDetails(this.props.session, (res) => {});
    // this.props.fetchEmailLog(this.props.session,0);
    this.props.fetchSettings(this.props.session);
    this.props.updateUnsavedChanges(false);
  }

  renderSettingOptionList() {
    let { settingMenus, eventData } = this.props;
    //console.log("settingMenus", settingMenus);
    return settingMenus.map((item, index) => {
      //console.log("item", item);
      if (
        item ||
        (eventData &&
          eventData.published &&
          eventData.packageon == "enterprise_pro" &&
          item.iconName == "appstore")
      ) {
        return <SettingMenu key={item.iconName} item={item} />;
      }
    });
  }

  render() {
    return (
      <div className="content-parent-container">
        <div className="content-submenu vertical-line">
          <div>
            <ul className="list-group">{this.renderSettingOptionList()}</ul>
          </div>
        </div>
        <div
          className="content-subcontainer"
          // style={{ width: `${contentContainerWidth}px` }}
        >
          {/* password will be under account settings */}
          <Route
            path="/dashboard/settings/passwordsetting"
            component={PasswordSetting}
          />
          <Route
            path="/dashboard/settings/eventsetting"
            component={EventSetting}
          />
          <Route
            path="/dashboard/settings/emailtemplate"
            component={EmailTemplate}
          />

          <Route path="/dashboard/settings/emaillog" component={EmailLog} />
          <Route path="/dashboard/settings/apis" component={APIS} />
          <Route
            path="/dashboard/settings/billings"
            component={BillingDetails}
          />
          <Route
            path="/dashboard/settings/language"
            component={LanguageSetting}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var eventData = {};
  if (state.eventData[0]) {
    eventData = state.eventData[0];
  }
  return {
    settingMenus: state.settingMenus,
    session: state.session,
    eventData,
  };
}

export default connect(mapStateToProps, {
  fetchTemplate,
  fetchEvent,
  fetchEmailLog,
  fetchSettings,
  updateUnsavedChanges,
  fetchEventDetails,
})(Settings);
